<ng-container *ngIf="isSmallIcon">
  <div
    class="file-upload-replace"
    nz-popover
    nzPopoverOverlayClassName="tooltip-sm"
    nzPopoverTrigger="hover"
    [nzPopoverContent]="'REPLACE_INVOICE' | translate"
  >
    <label class="file-upload-replace-img" [for]="id">
      <img class="file-upload-replace-img-icon" src="/assets/icons/icon_sync.svg" />
    </label>
  </div>
</ng-container>

<ng-container *ngIf="!isSmallIcon">
  <label
    class="file-upload"
    [for]="id"
    [ngClass]="{ 'drag-file-area': isHoverFile }"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
    (dragleave)="onDragLeave($event)"
  >
    <div class="file-upload-body">
      <div class="file-upload-body-text">
        <div class="d-none d-xl-inline-block">
          {{ "DRAG_N_DROP_OR" | translate }}
          <br />
          <span class="file-upload-body-browse">{{ "LABELS.BROWSE" | translate }}</span>
          {{ "FOR_UPLOAD" | translate }}
        </div>

        <div class="file-upload-body-text-mobile d-xl-none">
          <span class="file-upload-body-browse">{{ "LABELS.BROWSE" | translate }}</span>
          {{ "OCR_FORMATS_HINT" | translate }}
        </div>

        <div class="file-upload-body-text-errors">
          <app-control-errors [errors]="errors" [control]="fileControl" [isShowHelper]="false"></app-control-errors>
        </div>
      </div>
      <div class="file-upload-body-hint d-none d-xl-block">
        <app-hint-tooltip-icon *ngIf="!!hint" [hint]="hint | translate"></app-hint-tooltip-icon>
      </div>
    </div>
  </label>
</ng-container>

<input
  #inputElement
  class="d-none"
  type="file"
  [id]="id"
  [accept]="allowedFileMimes.join(',')"
  (click)="clickInput()"
  (change)="handleFiles($event)"
/>
